import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { getAllDepartment } from 'services/api/modules/performance/appraisal/department'

const EDDetailsTab = ({
  description,
  formId,
  form,
  dept,
  rule,
  letRevieweeView,
  letReviewerView,
  letFeedback,
  letAnonymous,
}) => {
  const navigate = useNavigate()
  const [departmentSelected, setDepartmentSelected] = useState([])
  const { state } = useLocation()
  const handleView = () => {
    navigate(`/app/appraisal-cycle/evaluation/${state.item.id}/form/preview/${formId}`, {
      state: { ...state, evaluationTabsValue: 0 },
    })
  }

  const { data: departmentData } = useQuery('allDepartmentData', async () => {
    const newData = { name: 'All Departments', id: 'all' }
    let { data } = await getAllDepartment()
    if (data) {
      data.push(newData)
      const evalDepartments = dept
      let arr = []

      data?.map((item) =>
        evalDepartments.map((evalDept) => (item.id === evalDept ? arr.push(item) : null))
      )
      data = arr
      return data
    }
  })

  useEffect(() => {
    setDepartmentSelected(departmentData)
  }, [departmentData])

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        padding={3}
        borderRadius={2}
        backgroundColor="white.main"
      >
        <Box>
          <Typography color="light-gray-text.main" mb={0.5}>
            Description
          </Typography>
          <Typography>{description}</Typography>
        </Box>
        <Box display="flex" gap={10}>
          <Box width="200px" display="flex" flexDirection="column" gap={2}>
            <Typography color="light-gray-text.main">Evaluation form</Typography>
            <Typography color="light-gray-text.main">Department</Typography>
            <Typography color="light-gray-text.main">Matching method</Typography>
          </Box>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" gap={1}>
              <Typography>{form}</Typography>
              <Typography
                color="alternate.main"
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={handleView}
              >
                View
              </Typography>
            </Box>
            {departmentSelected?.map((value, index) => (
              <Typography key={index}>{value.name}</Typography>
            ))}
            <Box display="flex" gap={1}>
              <Typography>{rule[0].toUpperCase() + rule.slice(1)}</Typography>
              {/* <Typography
                                color="alternate.main"
                                sx={{textDecoration:"underline", cursor:"pointer"}}
                                onClick={() => alert("navigate to view matching")}
                            >
                                View matching
                            </Typography> */}
            </Box>
          </Box>
        </Box>
      </Box>
      {/* <Box
                display="flex"
                flexDirection="column"
                gap={2}
                padding={3}
                borderRadius={2}
                backgroundColor="white.main"
            >
                <Box display="flex" gap={10}>
                    <Box width="200px" display="flex" flexDirection="column" gap={2}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography color="light-gray-text.main">Result visibility</Typography>
                            <AdxInfoIcon toolTipTitle="Generated group" />
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography color="light-gray-text.main">Evaluation feedback</Typography>
                            <AdxInfoIcon toolTipTitle="Generated group" />
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography color="light-gray-text.main">Anonymous submission</Typography>
                            <AdxInfoIcon toolTipTitle="Generated group" />
                        </Box>
                    </Box>
                    <Box display="flex" flexDirection="column" gap={2}> */}
      {/* For result visibility */}
      {/* {letRevieweeView && letReviewerView  ? 
                            <Typography>All</Typography>
                        : letRevieweeView && !letReviewerView ?
                            <Typography>Reviewee only</Typography>
                        : !letRevieweeView && letReviewerView ?
                            <Typography>Reviewer only</Typography>
                        : 
                            <Typography>None</Typography>
                        } */}

      {/* For evaluation feedback */}
      {/* {letFeedback ?
                            <Typography>Enabled</Typography>
                        :
                            <Typography>Disabled</Typography>
                        } */}

      {/* For anonymous submission */}
      {/* {letAnonymous ?
                            <Typography>Enabled</Typography>
                        :
                            <Typography>Disabled</Typography>
                        }
                    </Box>
                </Box>
            </Box> */}
    </Box>
  )
}

export default EDDetailsTab
